import React from 'react'
import { TYPE_VALUE_FILTERS } from './constants'

import MultiSelect from './MultiSelect'

import SpanPicker from './SpanPicker'

import moment from 'moment'

const Filters = ({ list = [], options, values, handleChange, className }) => {
    return (
        <div className={className}>
            {list.map(
                (
                    {
                        value,
                        label,
                        fillOptions,
                        type,
                        format
                    }: { value: string; label: string; fillOptions: boolean; type: string; format: string },
                    i: number
                ): JSX.Element => {
                    switch (type) {
                        case TYPE_VALUE_FILTERS.SELECT:
                            return (
                                <MultiSelect
                                    key={i}
                                    label={label}
                                    options={options[value] || []}
                                    placeholder={'Click to select...'}
                                    value={values[value]}
                                    onChange={e => handleChange(value, e)}
                                    style={{ marginBottom: '8px' }}
                                />
                            )
                            break
                        case TYPE_VALUE_FILTERS.SELECT_OBJECT:
                            return (
                                <MultiSelect
                                    key={i}
                                    label={label}
                                    options={options[value] || []}
                                    placeholder={'Click to select...'}
                                    value={values[value]}
                                    onChange={e => handleChange(value, e)}
                                    style={{ marginBottom: '8px' }}
                                />
                            )
                            break
                        case TYPE_VALUE_FILTERS.TIMESPAN:
                            return (
                                <SpanPicker
                                    key={i}
                                    label={label}
                                    start={values[`earliest${value.charAt(0).toUpperCase() + value.slice(1)}`]}
                                    end={values[`latest${value.charAt(0).toUpperCase() + value.slice(1)}`]}
                                    onChange={(date, type) => {
                                        if (type === 'start') {
                                            return handleChange(
                                                `earliest${value.charAt(0).toUpperCase() + value.slice(1)}`,
                                                moment(date).valueOf()
                                            )
                                        } else {
                                            return handleChange(
                                                `latest${value.charAt(0).toUpperCase() + value.slice(1)}`,
                                                moment(date).valueOf()
                                            )
                                        }
                                    }}
                                />
                            )
                            break
                        case TYPE_VALUE_FILTERS.INPUT:
                            // return <input />
                            break
                        default:
                            break
                    }
                }
            )}
        </div>
    )
}

export default Filters
